import React, { useEffect, useState } from "react";
import { ParentLayout } from "../../../layout/parentLayout";
import NewSideBarParent from "../../../components/NewSideBarParent";
import { RecommendedClasses } from "../../../components/RecommendedClasses";
import Chatbar from "../../../components/Chatbar";
import {
  FormControlLabel,
  styled,
  Switch,
  SwitchProps,
  TextField,
} from "@mui/material";
import { TabCard } from "../../../components/TabCard";
import {
  CLASS_LIST_TYPE,
  CLASS_TYPE,
  ClassMode,
  TeachingLanguage,
  TYPE_SUBJECT_LISTING,
} from "../../../constants/enums";
import { useGetClassesForParentQuery } from "../../../service/class";
import { Dropdown } from "../../../components/DropDownFilter";
import { useLazyGetSubjectsAndCategoryQuery } from "../../../service/auth";
import { useDebounce } from "../../../constants/useDebounce";
import { isValidInput } from "../../../utils/validations";

function Recommended() {
  const [query, setQuery] = useState<string>("");
  const debounceValue = useDebounce(query, 750);
  const [selectedValues, setSelectedValues] = useState<{
    [key: string]: string;
  }>({});
  const { data: classData } = useGetClassesForParentQuery({
    type: CLASS_LIST_TYPE.RECOMMENDED,
    page: 1,
    limit: 30,
    ...(selectedValues?.Subjects
      ? { subjectId: selectedValues?.Subjects }
      : {}),
    ...(selectedValues?.Language ? { language: selectedValues?.Language } : {}),
    ...(selectedValues?.Price ? { sortBy: selectedValues?.Price } : {}),
    ...(selectedValues?.Mode ? { classMode: selectedValues?.Mode } : {}),
    ...(selectedValues?.Type
      ? { canBePrivate: selectedValues?.Type == "1" ? false : true }
      : {}),
    ...(debounceValue ? { search: debounceValue } : {}),
  });

 

  const [getSubjects] = useLazyGetSubjectsAndCategoryQuery();
  const [subjects, setSubjects] = useState<any[]>([]);
  const fetchSubjects = async () => {
    try {
      const res = await getSubjects({
        type: TYPE_SUBJECT_LISTING.SUBJECT,
      }).unwrap();
      if (res?.statusCode == 200) {
        setSubjects(res?.data);
      }
    } catch (error: any) {}
  };

  const dropdownData = [
    {
      name: "Type",
      options: [
        { name: "Public", value: 1 },
        { name: "Private", value: 2 },
      ],  
    },
    {
      name: "Subjects",
      options:
        subjects?.map((item) => ({ name: item?.name, value: item?._id })) || [],
    },
    {
      name: "Price",
      options: [
        { name: "Low to High", value: 1 },
        { name: "High to Low", value: 1 },
      ],
    },
    {
      name: "Mode",
      options: [
        { name: "Online", value: ClassMode.ONLINE },
        { name: "Offline", value: ClassMode.OFFLINE },
        { name: "Online", value: ClassMode.HYBRID },
      ],
    },
    {
      name: "Language",
      options: [
        { name: "English", value: TeachingLanguage.ENGLISH },
        { name: "Arabic", value: TeachingLanguage.ARABIC },
      ],
    },
  ];
  const handleChange = (name: string, value: string) => {
    setSelectedValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const IOSSwitch = styled((props: SwitchProps) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#65C466",
          opacity: 1,
          border: 0,
          ...theme.applyStyles("dark", {
            backgroundColor: "#2ECA45",
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles("dark", {
          opacity: 0.3, 
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...theme.applyStyles("dark", {
        backgroundColor: "#39393D",
      }),
    },
  }));
  useEffect(() => {
    fetchSubjects();
  }, []);
  return (
    <>
      <ParentLayout className="role-layout">
        <main className="content">
          <section className="uh_spc pSearchResult_sc home_wrp">
            <div className="conta_iner v2">
              <div className="mn_fdx">
                <NewSideBarParent />
                <div className="mdl_cntnt ">
                  <div className=" control_group">
                    {/* <p>Switch to Private</p>
                    <FormControlLabel
                      control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
                      label=""
                    /> */}

                    <TextField
                      className="search-field"
                      placeholder="search.."
                      value={query}
                      onChange={(e) => {
                        if (isValidInput(e.target.value)) {
                          setQuery(e.target.value);
                        }
                      }}
                    />
                  </div>
                  <ul className="cstmm_tabs">
                    {dropdownData.map((dropdown) => (
                      <Dropdown
                        key={dropdown.name}
                        name={dropdown.name}
                        options={dropdown.options}
                        selected={selectedValues[dropdown.name] || ""}
                        onChange={(value) => handleChange(dropdown.name, value)}
                      />
                    ))}
                  </ul>
                  <div className="gap_m rec_clsss">
                    {classData?.data?.data?.length
                      ? classData?.data?.data?.map((item: any) => {
                          return <RecommendedClasses data={item} />;
                        })
                      : null}
                  </div>
                </div>
                <div className="sidebar_rt">
                  <Chatbar />
                  <section className="side_menu_wrap  page_link">
                    <ul>
                      <li>
                        <a>About Us</a>
                      </li>
                      <li>
                        <a>Contact Us</a>
                      </li>
                      <li>
                        <a>Help Center</a>
                      </li>
                      <li>
                        <a>Terms & conditions</a>
                      </li>
                      <li>
                        <a>Privacy Policy</a>
                      </li>
                      <li>
                        <a>FAQ’s</a>
                      </li>
                    </ul>
                  </section>
                </div>
              </div>
              {/* <SearchFilter
                setPage={setPage}
                setHasMore={setHasMore}
                setShowSearchResult={setShowSearchResult}
                fetchData={fetchData}
              />
              <div className="searchResult_box" ref={viewRef}>
                {showSearchResult ? <h2>Search Result</h2> : ""}
                <div className="gap_p">
                  {showSearchResult ? (
                    <div className="lt_s">
                      <div className="tutor_list gap_m">
                        {isLoading && list?.length === 0
                          ? Array.from(new Array(12)).map((item, index) => (
                              <Skeleton
                                variant="rounded"
                                animation="wave"
                                width={210}
                                height={220}
                                key={index}
                                sx={{
                                  bgcolor: "#FCFDFFEF",
                                  borderRadius: "8px",
                                }}
                              />
                            ))
                          : list?.map((item, index) => (
                              <div
                                className="tutor_item"
                                key={item?._id}
                                onClick={() =>
                                  navigate(`/parent/tutor-detail/${item?._id}`)
                                }
                              >
                                <figure>
                                  <img
                                    src={
                                      item?.image || `/static/images/userNew.png`
                                    }
                                    alt="Image"
                                  />
                                  <span className="t_rating">
                                    <StarIcon />{" "}
                                    {item?.avgRating?.toFixed(1) || "0"}
                                  </span>
                                  <span className="t_fav">
                                    {item?.isFav ? (
                                      <FavoriteIcon />
                                    ) : (
                                      <FavoriteBorderIcon />
                                    )}
                                  </span>
                                  {item?.documentVerification ? (
                                    <span className="t_verify">
                                      <img
                                        src="/static/images/verified.png"
                                        alt="img"
                                      />
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </figure>
                                <div
                                  className="tutor_info"
                                  onClick={() =>
                                    navigate(
                                      `/parent/tutor-detail/${item?._id}`
                                    )
                                  }
                                >
                                  <h2>{item?.name || ""}</h2>
                                  <p>
                                    {item?.classCount > 99
                                      ? "99+ classes"
                                      : `${item?.classCount || 0} ${item?.classCount > 1 ? "classes" : "class"}` ||
                                        ""}
                                  </p>
                                  <p>{item?.subjects?.join(" , ") || ""}</p>
                                  <ins>${item?.price || ""}/hour</ins>
                                </div>
                              </div>
                            ))}
                        {list?.length === 0 ? (
                          <div
                            style={{ textAlign: "center", fontSize: "30px" }}
                          >
                            No Tutors found
                          </div>
                        ) : (
                          ""
                        )}
                        {list?.length ? (
                          <Pagination
                            module={list}
                            page={page}
                            onPageChange={onPageChange}
                            totalPages={totalPages}
                          />
                        ) : (
                          ""
                        )}
                  
                      </div>
                    </div>
                  ) : (
                    <div className="lt_s">
                      {currentBooking && (
                        <div className="dash_title">
                          <h2>Today’s Booking</h2>
                          <Box
                            component="a"
                            onClick={() => navigate("/parent/my-bookings")}
                          >
                            View more <ArrowForwardIosIcon />
                          </Box>
                        </div>
                      )}

                      {isLoadingOne ? (
                        <Box
                          sx={{
                            padding: 2,
                            borderRadius: 2,
                            backgroundColor: "#FCFDFFEF",
                            marginTop: 5,
                          }}
                        >
                          <Grid container spacing={2} alignItems="center">
                        
                            <Grid item>
                              <Skeleton
                                variant="rounded"
                                width={150}
                                height={150}
                              />
                            </Grid>

                
                            <Grid item xs>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Skeleton
                                  variant="text"
                                  width="40%"
                                  height={28}
                                />{" "}
             
                                <Skeleton
                                  variant="rectangular"
                                  width={120}
                                  height={32}
                                  sx={{ borderRadius: 1 }}
                                />{" "}
                  
                              </Box>
                              <Skeleton
                                variant="rectangular"
                                width={160}
                                height={20}
                                sx={{ borderRadius: 1, marginTop: 1 }}
                              />{" "}
                           
                              <Grid container spacing={2} sx={{ marginTop: 2 }}>
                                <Grid item>
                                  <Skeleton
                                    variant="text"
                                    width={120}
                                    height={20}
                                  />{" "}
                    
                                </Grid>
                                <Grid item>
                                  <Skeleton
                                    variant="text"
                                    width={60}
                                    height={20}
                                  />{" "}
                    
                                </Grid>
                                <Grid item>
                                  <Skeleton
                                    variant="text"
                                    width={60}
                                    height={20}
                                  />{" "}
                        
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      ) : (
                        currentBooking && (
                          <div className="booking_box">
                            <figure>
                              <img
                                src={
                                  currentBooking?.tutors?.image ||
                                  `/static/images/userNew.png`
                                }
                                alt="Image"
                              />
                            </figure>
                            <div className="info">
                              <div className="flex">
                                <div className="lt">
                                  <h3>{currentBooking?.tutors?.name || ""}</h3>
                                  <span className="code">
                                    Booking Code -{" "}
                                    <strong>
                                      {currentBooking?.bookingdetails[0]?.otp
                                        ?.otp || ""}
                                    </strong>
                                  </span>
                                </div>
                                <div className="rt">
                                  <Button onClick={toggleDrawer(true)}>
                                    <img
                                      src={`/static/images/map_icon.svg`}
                                      alt="Icon"
                                    />
                                    Track Location
                                  </Button>
                                </div>
                              </div>
                              <ul>
                                <li>
                                  <span>Date & Time</span>
                                  <strong>
                                    {dayjs(
                                      currentBooking?.bookingdetails[0]
                                        ?.startTime
                                    )
                                      .locale("D MMMM, YY [at] HH:mm")
                                      .format("D MMMM,YYYY, hh:mm a")}
                                  </strong>
                                </li>
                                <li>
                                  <span>Subject</span>
                                  <strong>
                                    {currentBooking?.subjects[0]?.name || ""}
                                  </strong>
                                </li>
                                <li>
                                  <span>Price</span>
                                  <strong>
                                    $
                                    {currentBooking?.teachingdetails?.price ||
                                      ""}
                                    /Hour
                                  </strong>
                                </li>
                              </ul>
                            </div>
                          </div>
                        )
                      )}
                      {prevTutor?.length > 0 && (
                        <div className="dash_title">
                          <h2>Tutors You Booked Previously</h2>
                
                        </div>
                      )}
                      <div className="tutor_list gap_m">
                        {isLoadingOne
                          ? Array.from(new Array(3)).map((item, index) => (
                              <Skeleton
                                variant="rounded"
                                animation="wave"
                                width={210}
                                height={220}
                                key={index}
                                sx={{
                                  bgcolor: "#FCFDFFEF",
                                  borderRadius: "8px",
                                }}
                              />
                            ))
                          : prevTutor?.map((item, index) => (
                              <div
                                className="tutor_item"
                                key={item?._id}
                                onClick={() =>
                                  navigate(`/parent/tutor-detail/${item?._id}`)
                                }
                              >
                                <figure>
                                  <img
                                    src={
                                      item?.image || "static/images/card1.png"
                                    }
                                    alt="tutor image"
                                  />

                                  <span className="t_rating">
                                    <StarIcon />{" "}
                                    {item?.avgRating?.toFixed(1) || "0"}
                                  </span>
                                  {item?.documentVerification ? (
                                    <span className="t_verify">
                                      <img
                                        src="/static/images/verified.png"
                                        alt="img"
                                      />
                                    </span>
                                  ) : (
                                    ""
                                  )}

                                  <span
                                    className="t_fav"
                                    onClick={() => {
                                      handleWishList(item);
                                    }}
                                  >
                                    {item?.isFav ? (
                                      <FavoriteIcon />
                                    ) : (
                                      <FavoriteBorderIcon />
                                    )}
                                  </span>
                                  {item?.documentVerification ? (
                                    <span className="t_verify">
                                      <img
                                        src="/static/images/verified.png"
                                        alt="img"
                                      />
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </figure>
                                <div
                                  className="tutor_info"
                                  onClick={() =>
                                    navigate(
                                      `/parent/tutor-detail/${item?._id}`
                                    )
                                  }
                                >
                                  <h2>{item?.name || ""}</h2>
                                  <p>
                                    {item?.classCount > 99
                                      ? "99+ classes"
                                      : `${item?.classCount || 0} ${item?.classCount > 1 ? "classes" : "class"}` ||
                                        ""}
                                  </p>
                                  <p>
                                    {(item?.subjects &&
                                      item?.subjects?.join(",")) ||
                                      ""}
                                  </p>
                                  <ins>${item?.price || ""}/hour</ins>
                                </div>
                              </div>
                            ))}
                      </div>

                      <div className="dash_title">
                        <h2>Popular Tutors</h2>
                        <Box
                          component="a"
                          onClick={() => navigate("/parent/popular-tutor")}
                        >
                          View more <ArrowForwardIosIcon />
                        </Box>
                      </div>
                      <div className="tutor_list gap_m">
                        {isLoading
                          ? Array.from(new Array(3)).map((item, index) => (
                              <Skeleton
                                variant="rounded"
                                animation="wave"
                                width={210}
                                height={220}
                                key={index}
                                sx={{
                                  bgcolor: "#FCFDFFEF",
                                  borderRadius: "8px",
                                }}
                              />
                            ))
                          : popularTutor?.map((item, index) => (
                              <div
                                className="tutor_item"
                                key={item?._id}
                                onClick={() =>
                                  navigate(`/parent/tutor-detail/${item?._id}`)
                                }
                              >
                                <figure>
                                  <img
                                    src={
                                      item?.image || "/static/images/userNew.png"
                                    }
                                    alt="tutor image"
                                  />
                                  <span className="t_rating">
                                    <StarIcon />{" "}
                                    {item?.avgRating?.toFixed(1) || "0"}
                                  </span>
                                  <span
                                    className="t_fav"
                                    onClick={() => {
                                      handleWishList(item);
                                    }}
                                  >
                                    {item?.isFav ? (
                                      <FavoriteIcon />
                                    ) : (
                                      <FavoriteBorderIcon />
                                    )}
                                  </span>
                                  {item?.documentVerification ? (
                                    <span className="t_verify">
                                      <img
                                        src="/static/images/verified.png"
                                        alt="img"
                                      />
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </figure>
                                <div
                                  className="tutor_info"
                                  onClick={() =>
                                    navigate(
                                      `/parent/tutor-detail/${item?._id}`
                                    )
                                  }
                                >
                                  <h2>{item?.name || ""}</h2>
                                  <p>
                                    {item?.classCount > 99
                                      ? "99+ classes"
                                      : `${item?.classCount ? item?.classCount : 0} ${item?.classCount > 1 ? "classes" : "class"}` ||
                                        ""}
                                  </p>
                                  <p>
                                    {(item?.subjects &&
                                      item?.subjects?.join(",")) ||
                                      ""}
                                  </p>
                                  <ins>${item?.price || ""}/hour</ins>
                                </div>
                              </div>
                            ))}
                      </div>

                      <div className="dash_title">
                        <h2>Recomended Tutors</h2>
                        <Box
                          component="a"
                          onClick={() => navigate("/parent/recomended-tutor")}
                        >
                          View more <ArrowForwardIosIcon />
                        </Box>
                      </div>
                      <div className="tutor_list gap_m">
                        {isLoading
                          ? Array.from(new Array(3)).map((item, index) => (
                              <Skeleton
                                variant="rounded"
                                animation="wave"
                                width={210}
                                height={220}
                                key={index}
                                sx={{
                                  bgcolor: "#FCFDFFEF",
                                  borderRadius: "8px",
                                }}
                              />
                            ))
                          : recommended?.map((item, index) => (
                              <div
                                className="tutor_item"
                                key={item?._id}
                                onClick={() =>
                                  navigate(`/parent/tutor-detail/${item?._id}`)
                                }
                              >
                                <figure>
                                  <img
                                    src={
                                      item?.image || "static/images/card1.png"
                                    }
                                    alt="tutor image"
                                  />
                                  <span className="t_rating">
                                    <StarIcon />{" "}
                                    {item?.avgRating?.toFixed(1) || "0"}
                                  </span>
                                  <span
                                    className="t_fav"
                                    onClick={() => {
                                      handleWishList(item);
                                    }}
                                  >
                                    {item?.isFav ? (
                                      <FavoriteIcon />
                                    ) : (
                                      <FavoriteBorderIcon />
                                    )}
                                  </span>
                                  {item?.documentVerification ? (
                                    <span className="t_verify">
                                      <img
                                        src="/static/images/verified.png"
                                        alt="img"
                                      />
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </figure>
                                <div
                                  className="tutor_info"
                                  onClick={() =>
                                    navigate(
                                      `/parent/tutor-detail/${item?._id}`
                                    )
                                  }
                                >
                                  <h2>{item?.name || ""}</h2>
                                  <p>
                                    {item?.classCount > 99
                                      ? "99+ classes"
                                      : `${item?.classCount || 0} ${item?.classCount > 1 ? "classes" : "class"}` ||
                                        ""}
                                  </p>
                                  <p>
                                    {(item?.subjects &&
                                      item?.subjects?.join(",")) ||
                                      ""}
                                  </p>
                                  <ins>${item?.price || ""}/hour</ins>
                                </div>
                              </div>
                            ))}
                      </div>
                    </div>
                  )}

           
                  <div className="rt_s">
                    <div className="map">
                      <GoogleMap
                        mapContainerClassName="map_container"
                        center={center}
                        zoom={5}
                      >
                        {parentAdd &&
                          parentAdd.latitude &&
                          parentAdd.longitude && (
                            <MarkerF
                              key="parent-add-marker"
                              position={{
                                lat: parentAdd.latitude,
                                lng: parentAdd.longitude,
                              }}
                              icon={{
                                url:
                                  parentAdd?.image ||
                                  "`/static/images/user.png`", 
                                scaledSize: new window.google.maps.Size(40, 40), 
                              }}
                              onClick={() => setSelectedTutor(parentAdd)} 
                            />
                          )}

                        {showSearchResult ? (
                          list?.length ? (
                            list.map((tutor, index) => (
                              <MarkerF
                                key={`popular-tutor-${index}`}
                                position={{
                                  lat: tutor?.latitude,
                                  lng: tutor?.longitude,
                                }}
                                onClick={() => setSelectedTutor(tutor)}
                              />
                            ))
                          ) : null
                        ) : (
                          <>
                            {popularTutor?.slice(0, 6).map((tutor, index) => (
                              <MarkerF
                                key={`popular-tutor-${index}`}
                                position={{
                                  lat: tutor?.latitude,
                                  lng: tutor?.longitude,
                                }}
                                onClick={() => setSelectedTutor(tutor)} 
                              />
                            ))}
                            {recommended?.slice(0, 6).map((tutor, index) => (
                              <MarkerF
                                key={`recommended-tutor-${index}`}
                                position={{
                                  lat: tutor?.latitude,
                                  lng: tutor?.longitude,
                                }}
                                onClick={() => setSelectedTutor(tutor)} 
                              />
                            ))}
                          </>
                        )}

                        {selectedTutor && (
                          <InfoWindowF
                            position={{
                              lat: selectedTutor?.latitude,
                              lng: selectedTutor?.longitude,
                            }}
                            onCloseClick={() => setSelectedTutor(null)} 
                          >
                            <div>
                              <h6>{selectedTutor?.name || ""}</h6>
                              <p>{selectedTutor?.address || ""}</p>
                              <img
                                src={
                                  selectedTutor?.image
                                    ? selectedTutor?.image
                                    : "`/static/images/user.png`"
                                }
                                alt="img"
                                style={{ width: "100px", height: "100px" }}
                              />
                            </div>
                          </InfoWindowF>
                        )}
                      </GoogleMap>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </section>
        </main>
      </ParentLayout>
    </>
  );
}

export default Recommended;
